import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Hyperlink } from '@edx/paragon';

function Citation({
  className,
  footnoteId,
  footnoteMap,
  linkVariant,
}) {
  if (!footnoteId || !footnoteMap || !footnoteMap[footnoteId]) {
    return null;
  }

  const footnotePosition = footnoteMap[footnoteId];

  return (
    <span id={`citation-${footnoteId}`} className="citation">
      <sup>
        <Hyperlink
          destination={`#footnote-${footnoteId}`}
          className={className}
          variant={linkVariant}
          role="doc-noteref"
        >
          <span className="sr-only">Footnote </span>{footnotePosition}
        </Hyperlink>
      </sup>
    </span>
  );
}

Citation.propTypes = {
  className: PropTypes.string,
  footnoteId: PropTypes.string.isRequired,
  footnoteMap: PropTypes.objectOf(PropTypes.number).isRequired,
  linkVariant: PropTypes.oneOf(['default', 'muted', 'brand']),
};

Citation.defaultProps = {
  className: '',
  linkVariant: 'default',
};

export default Citation;
